import { render, staticRenderFns } from "./Yfstmh.vue?vue&type=template&id=0a6a3c22&scoped=true&"
import script from "./Yfstmh.vue?vue&type=script&lang=js&"
export * from "./Yfstmh.vue?vue&type=script&lang=js&"
import style0 from "./Yfstmh.vue?vue&type=style&index=0&id=0a6a3c22&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6a3c22",
  null
  
)

export default component.exports